import { Handle } from '../domain';

export const isExtrusionPull = (model: Handle): boolean => {
    if(model.assetId) {
        return Boolean(model.isExtrusionPull);
    } else {
        return model.style.includes('pull-elite');
    }
}
